import { ShareButton } from '../../../ShareButton';
import { ShareSectionHeading } from '../ShareSectionHeading';

export const ShareSlideUpButton: React.FC<EmptyProps> = () => {
	return (
		<div className="mb-3 flex flex-col gap-5">
			<ShareSectionHeading />
			<ShareButton />
		</div>
	);
};
